import { useState } from "react";
import { StarRating } from "./StarRating"
import { IAgent } from "types/artifacts/common";
import { trackEvent } from "services/api-client/matomoTracker";

export interface IAgentDetailCardProps {
    agent: IAgent;
}

export const AgentDetailCard = ({ agent }: IAgentDetailCardProps): JSX.Element => {
    const [isPhoneNumberShown, setIsPhoneNumberShown] = useState(false);
    const { agentname, biourl, photo_large, agentphone, officename, officeurl, mls_plantinum, rating, membernumber } = agent;
    const trackViewProfile = () => trackEvent(`AI Mode / Agent Search View Profile / ${agentname}`);
    return (
        <div style={{ maxWidth: '600px' }}>
            <div className="agent_signature--square mt-2">
                <div className="agent_signature agent_signature--square__photo">
                    <a
                        href={biourl}
                        title={`View ${agentname} profile`}
                        style={{
                            backgroundImage: `url(${photo_large})`,
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={trackViewProfile}
                    />
                </div>
                <div className="agent_signature--square__info">
                    <a
                        className="agent_signature--square__info__agent_name truncated"
                        href={biourl}
                        title={`View ${agentname} profile`}
                        aria-label={`View ${agentname} profile`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={trackViewProfile}
                    >
                        {agentname}
                    </a>
                    <div className="agent_signature--square__info__broker_name">
                        <div className="d-flex pb-md-2 align-items-center">
                            {mls_plantinum === "1" && (
                                <div className="mr-2 pt-1">
                                    <img
                                        alt="Platinum Member"
                                        style={{ width: '75px' }}
                                        src="https://content.harstatic.com/media/icons/label-platinum.svg"
                                    />
                                </div>
                            )}
                            {rating && (
                                <div className="stars">
                                    <StarRating rating={parseFloat(rating)} />
                                    <span className="font_weight--bold ml-1 align-middle">{Number(rating || '').toFixed(2)}</span>
                                    /<span className="mr-2 align-middle">5</span>
                                </div>
                            )}

                        </div>
                        {officename && (
                            <a
                                className="mr-3 truncated"
                                href={`https://www.har.com${officeurl || ''}`}
                                title={officename}
                                aria-label={`View ${officename} profile`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={trackViewProfile}
                            >
                                {officename}
                            </a>
                        )}
                        <div className="d-flex align-items-center pt-1">
                            {agentphone && (
                                <>
                                    {isPhoneNumberShown ? (
                                        <a className="pr-3 link" href={`tel:${agentphone}`}>
                                            {agentphone}
                                        </a>
                                    ) : (
                                        <span style={{ fontSize: '14px' }} onClick={() => { trackEvent(`AI Mode / Agent Search View Phone / ${agentname}`); setIsPhoneNumberShown(true); }} className="pr-3 link cursor--pointer" data-phone={agentphone}>
                                            View Phone
                                        </span>
                                    )}
                                </>
                            )}
                            <a className="pr-3 link" href={`${biourl}#contactAgentBox`} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent(`AI Mode / Agent Search View Email / ${agentname}`)}>
                                Send Email
                            </a>
                        </div>
                        {membernumber && <span style={{ fontSize: '14px' }} className="pr-3" >Member #: {membernumber} </span>}
                    </div>
                </div>
            </div>
        </div >
    )
}

